document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('[data-parts-form]');

    forms.forEach((wrapper) => {
        initPartsForm(wrapper);
    });
});

function initPartsForm(wrapper) {
    const form = wrapper.querySelector('.parts-form');

    if (!form) {
        return;
    }

    const steps = wrapper.querySelectorAll('[data-form-step]');
    const progressSteps = wrapper.querySelectorAll('[data-progress-step]');
    const nextButtons = wrapper.querySelectorAll('[data-next-step]');
    const previousButtons = wrapper.querySelectorAll('[data-previous-step]');

    const partTypeButtons = wrapper.querySelectorAll('[data-part-type]');
    const partTypeInput = wrapper.querySelector('[data-part-type-input]');
    const message = form.querySelector('[data-form-message]');
    const imageInput = form.querySelector('#pr-images');
    const uploadedFiles = form.querySelector('[data-uploaded-files]');

    let currentStep = 1;

    function getStep(stepNumber) {
        return wrapper.querySelector(
            `[data-form-step="${stepNumber}"]`
        );
    }

    function isStepValid(stepNumber) {
        const step = getStep(stepNumber);

        if (!step) {
            return false;
        }

        const requiredFields = step.querySelectorAll(
            'input[required], select[required], textarea[required]'
        );

        for (const field of requiredFields) {
            if (!field.checkValidity()) {
                return false;
            }
        }

        return true;
    }

    function updateButtons() {
        const activeStep = getStep(currentStep);

        if (!activeStep) {
            return;
        }

        const stepIsValid = isStepValid(currentStep);

        const nextButton = activeStep.querySelector(
            '[data-next-step]'
        );

        const submitButton = activeStep.querySelector(
            'button[type="submit"]'
        );

        if (nextButton) {
            nextButton.disabled = !stepIsValid;
        }

        if (submitButton) {
            submitButton.disabled = !stepIsValid;
        }
    }

    function showMessage(text, type) {
        if (!message) {
            return;
        }

        message.textContent = text;

        message.classList.remove(
            'is-success',
            'is-error'
        );

        message.classList.add(
            type === 'success'
                ? 'is-success'
                : 'is-error'
        );

        message.hidden = false;
    }

    function hideMessage() {
        if (!message) {
            return;
        }

        message.hidden = true;
        message.textContent = '';

        message.classList.remove(
            'is-success',
            'is-error'
        );
    }

    let selectedFiles = [];

    function formatFileSize(size) {
        if (size < 1024 * 1024) {
            return `${Math.max(1, Math.round(size / 1024))} KB`;
        }

        return `${(size / 1024 / 1024).toFixed(2)} MB`;
    }

    function renderUploadedFiles() {
        if (!uploadedFiles) {
            return;
        }

        uploadedFiles.innerHTML = '';

        selectedFiles.forEach((file, index) => {
            const item = document.createElement('div');

            item.className = 'parts-form__uploaded-file';

            const isImage = file.type.startsWith('image/');

            item.innerHTML = `
                <div class="parts-form__uploaded-file-preview">
                    ${isImage
                        ? '<img class="parts-form__uploaded-file-image" alt="">'
                        : '<span class="parts-form__uploaded-file-pdf">PDF</span>'
                    }

                    <div class="parts-form__uploaded-file-overlay">
                        <span class="parts-form__uploaded-file-name">${file.name}</span>
                        <span class="parts-form__uploaded-file-size">${formatFileSize(file.size)}</span>

                        <button type="button" class="parts-form__uploaded-file-remove" data-file-index="${index}" aria-label="Remove ${file.name}">
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M6 6l12 12"></path>
                                <path d="M18 6L6 18"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            `;

            if (isImage) {
                const image = item.querySelector('.parts-form__uploaded-file-image');
                const objectUrl = URL.createObjectURL(file);

                image.src = objectUrl;

                image.addEventListener('load', () => {
                    URL.revokeObjectURL(objectUrl);
                }, { once: true });
            }

            uploadedFiles.appendChild(item);
        });

        if (selectedFiles.length < 10) {
            const addButton = document.createElement('label');

            addButton.className = 'parts-form__upload-add';
            addButton.setAttribute('for', 'pr-images');

            addButton.innerHTML = `
                <span class="parts-form__upload-add-icon">+</span>
                <span class="parts-form__upload-add-text">Add</span>
            `;

            uploadedFiles.appendChild(addButton);
        }

        const dataTransfer = new DataTransfer();

        selectedFiles.forEach((file) => {
            dataTransfer.items.add(file);
        });

        imageInput.files = dataTransfer.files;
    }

    if (imageInput) {
        imageInput.addEventListener('change', () => {
            const files = Array.from(imageInput.files);

            const remainingSlots = 10 - selectedFiles.length;

            const filesToAdd = files.slice(0, remainingSlots);

            filesToAdd.forEach((file) => {
                const isAllowedType =
                    file.type.startsWith('image/') ||
                    file.type === 'application/pdf';

                const isAllowedSize =
                    file.size <= 10 * 1024 * 1024;

                if (!isAllowedType) {
                    showMessage(
                        'Only JPG, PNG, WebP, GIF or PDF files can be uploaded.',
                        'error'
                    );

                    return;
                }

                if (!isAllowedSize) {
                    showMessage(
                        `${file.name} is larger than 10 MB.`,
                        'error'
                    );

                    return;
                }

                selectedFiles.push(file);
            });

            if (files.length > remainingSlots) {
                showMessage(
                    'You can upload a maximum of 10 files.',
                    'error'
                );
            }

            imageInput.value = '';

            renderUploadedFiles();
        });
    }

    if (uploadedFiles) {
        uploadedFiles.addEventListener('click', (event) => {
            const removeButton = event.target.closest(
                '[data-file-index]'
            );

            if (!removeButton) {
                return;
            }

            const removeIndex = Number(
                removeButton.dataset.fileIndex
            );

            selectedFiles.splice(removeIndex, 1);

            renderUploadedFiles();
        });
    }

    function updateProgress() {
        progressSteps.forEach((progressStep) => {
            const stepNumber = Number(
                progressStep.dataset.progressStep
            );

            progressStep.classList.remove(
                'is-active',
                'is-completed'
            );

            if (stepNumber === currentStep) {
                progressStep.classList.add('is-active');
            }

            if (stepNumber < currentStep) {
                progressStep.classList.add('is-completed');
                progressStep.disabled = false;
            } else {
                progressStep.disabled = true;
            }
        });
    }

    function showStep(stepNumber) {
        const targetStep = getStep(stepNumber);

        if (!targetStep) {
            return;
        }

        currentStep = stepNumber;

        steps.forEach((step) => {
            const number = Number(
                step.dataset.formStep
            );

            step.classList.toggle(
                'is-active',
                number === currentStep
            );
        });

        updateProgress();
        updateButtons();
        // if (stepNumber !== 1) {
        //     wrapper.scrollIntoView({
        //         behavior: 'smooth',
        //         block: 'start'
        //     });
        // }
    }

    partTypeButtons.forEach((button) => {
        button.addEventListener('click', () => {
            partTypeButtons.forEach((item) => {
                item.classList.remove('is-selected');
            });

            button.classList.add('is-selected');

            if (partTypeInput) {
                partTypeInput.value =
                    button.dataset.partType || '';
            }

            updateButtons();
        });
    });

    form.addEventListener('input', () => {
        hideMessage();
        updateButtons();
    });

    form.addEventListener('change', () => {
        hideMessage();
        updateButtons();
    });

    nextButtons.forEach((button) => {
        button.addEventListener('click', () => {
            if (!isStepValid(currentStep)) {
                const activeStep = getStep(currentStep);

                if (activeStep) {
                    const firstInvalidField = activeStep.querySelector(
                        'input[required]:invalid, select[required]:invalid, textarea[required]:invalid'
                    );

                    if (firstInvalidField) {
                        firstInvalidField.reportValidity();
                    }
                }

                updateButtons();

                return;
            }

            const nextStep = currentStep + 1;

            if (nextStep <= steps.length) {
                showStep(nextStep);
            }
        });
    });

    previousButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const previousStep = currentStep - 1;

            if (previousStep >= 1) {
                showStep(previousStep);
            }
        });
    });

    progressSteps.forEach((progressStep) => {
        progressStep.addEventListener('click', () => {
            const targetStep = Number(
                progressStep.dataset.progressStep
            );

            if (targetStep < currentStep) {
                showStep(targetStep);
            }
        });
    });

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const redirectLink = form.dataset.redirectLink;
        const button = form.querySelector('button[type="submit"]');

        hideMessage();

        if (!form.checkValidity()) {
            form.reportValidity();
            updateButtons();
            return;
        }

        button.disabled = true;

        try {
            var response = await fetch(form.action, { method: "POST", body: new FormData(form) });
            var result = await response.json();

            if (result.ok) {
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'quote_form_submission', {
                        'event_category': 'Engagement',
                        'event_label': 'Quote Form',
                        'form_name': 'Get a Fast Quote',
                        'send_to': 'G-825PH92FGZ'
                    });
                }

                form.reset();

                if (redirectLink) {
                    window.location = redirectLink;
                } else {
                    message.textContent = "Thank you! Your request has been sent — we will get back to you shortly.";
                }
            } else if (result.errors) {
                message.textContent = "Please check the form: " +
                    Object.keys(result.errors).map(function (key) {
                        return key.replace(/_/g, " ") + " — " + result.errors[key].toLowerCase();
                    }).join("; ");
            } else {
                message.textContent = result.error || "Something went wrong. Please try again.";
            }
        } catch (error) {
            message.textContent = "Could not send the request. Please try again.";
        } finally {
            message.hidden = false;
            button.disabled = false;
        }

        console.log('Parts form submitted');
    });

    showStep(1);

    /* PREFILL FORM DATA */
    const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term",
                "utm_content", "gclid", "gbraid", "wbraid", "fbclid", "msclkid"];
    const params = new URLSearchParams(location.search);
    KEYS.forEach(function (key) {
      if (params.get(key)) sessionStorage.setItem("pr_" + key, params.get(key));
      const input = form.querySelector('input[name="' + key + '"]');
      if (input) input.value = sessionStorage.getItem("pr_" + key) || "";
    });
    if (!sessionStorage.getItem("pr_landing")) sessionStorage.setItem("pr_landing", location.href);
    if (form.querySelector('input[name="landing_page"]')) {
        form.querySelector('input[name="landing_page"]').value = sessionStorage.getItem("pr_landing");
    }
    if (form.querySelector('input[name="referrer"]')) {
        form.querySelector('input[name="referrer"]').value = document.referrer;
    }
}